<template>
  <div class="picker">
    <label :for="model.street.$key">
      {{ model.street.$schema.title }}
    </label>

    <v-select
      :class="{'is-invalid': this.model.street.$error}"
      :disabled="streetDisabled"
      :inputId="model.street.$key"
      :options="streets"
      :placeholder="streetPlaceholder"
      :value="streetValue"
      @search:blur="blur"
      @search:focus="focus"
      @input="selectedStreet"
      @search="getStreetList"
    >
      <template v-slot:no-options>
        {{ emptyListMsg }}
      </template>
    </v-select>

    <w-error v-if="showError" :model="this.model.street"></w-error>
  </div>
</template>

<script>
import axios from 'axios';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

import WError from './error.vue';

// @vuese
// Input na ULIC-a
// @group Components
export default {
  name: 'w-ulic-picker',
  components: {vSelect, WError},
  props: {
    // URL do TERYT API
    url: {
      type: String,
      required: true
    },
    // Schema
    model: {
      type: Object,
      required: true
    },
    // Wartość TERC-a
    terc: {
      type: String,
      required: true
    },
    // Wartość SIMC-a
    simc: {
      type: String,
      required: true
    },
    // Placeholder
    placeholder: {
      type: String,
      required: false,
      default: 'Wpisz nazwę ulicy'
    },
    // Tekst do wyświetlenia w przypadku pustej listy
    emptyListMsg: {
      type: String,
      required: false,
      default: ''
    },
    // Czy pokazywać błędy
    showError: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      streets: [],
      streetValue: undefined,
      streetDisabled: true,
      streetPlaceholder: ''
    };
  },
  watch: {
    'model.ulic.$value'(val) {
      this.setStreetData(val);
    },
    simc(newValue) {
      this.selectedStreet(undefined);
      this.$set(this, 'streets', []);

      if (newValue) {
        this.checkULICList();
      } else {
        this.setFormField(true, '');
      }
    }
  },
  methods: {
    // @vuese
    // Blur na polu schemy
    blur() {
      this.model.street.$hasFocus = false;
    },
    // @vuese
    // Focus na polu schemy
    focus() {
      this.model.street.$hasFocus = true;
    },
    // @vuese
    // Sprawdza czy lista ulic nie jest pusta
    checkULICList() {
      if (this.terc && this.simc) {
        axios
          .get(`${this.url}/ulic/?terc=${this.terc}&placeSymbol=${this.simc}&count=1`)
          .then(res => {
            if (res.data.list.length === 0) {
              this.setFormField(true, this.model.city.$value);
            } else {
              this.setFormField(false, this.placeholder);
              this.getStreetList('');
            }
          })
          .catch(error => this.$emit('error', 'Nie udało się pobrać listy ulic'));
      }
    },
    // @vuese
    // Pobiera listę ulic
    // @arg `searchText` - fragment nazwy ulicy do wyszukania
    getStreetList(searchText) {
      this.$set(this, 'streetValue', undefined);

      if (this.terc && this.simc) {
        axios
          .get(`${this.url}/ulic/?terc=${this.terc}&placeSymbol=${this.simc}&search=${searchText}`)
          .then(res => {
            this.streets = res.data.list.map(item => ({value: item.symbol, label: item.nameFull}));
          })
          .catch(error => this.$emit('error', 'Nie udało się pobrać listy ulic'));
      }
    },
    // @vuese
    // Zapisuje wybraną wartość w schemie
    // @arg `val` - obiekt z nazwą oraz symbolem ulicy
    selectedStreet(val) {
      this.$set(this, 'streetValue', val);

      this.model.$setData({
        street: val ? val.label : '',
        ulic: val ? val.value : ''
      });

      if (!val) {
        this.getStreetList('');
      }
    },
    // @vuese
    // Pobiera i ustawia ulicę w formularzu
    // @arg `ulic` - kod ULIC
    setStreetData(ulic) {
      if (this.simc && ulic) {
        axios
          .get(`${this.url}/ulic/${this.simc}/${ulic}`)
          .then(res => {
            const street = {value: res.data.symbol, label: res.data.nameFull};
            this.streets = [street];
            this.$set(this, 'streetValue', street);
          })
          .catch(error => this.$emit('error', 'Nie udało się pobrać listy ulic'));
      }
    },
    // @vuese
    // Blokuje/aktywuje pole formularza oraz ustawia placeholdera
    // @arg `disabled` - czy pole ma być zablokowane?
    // @arg `placeholder` - tekst placeholdera
    setFormField(disabled, placeholder) {
      this.$set(this, 'streetDisabled', disabled);
      this.$set(this, 'streetPlaceholder', placeholder);
    }
  },
  beforeMount() {
    this.checkULICList();

    if (this.model.ulic) {
      this.setStreetData(this.model.ulic.$value);
    }
  }
};
</script>

<style>
.picker {
  margin-bottom: 25px;
}

.is-invalid .vs__dropdown-toggle {
  border-color: #fd3995;
}
</style>
